import React, { useState,useEffect } from 'react';
import API from '../../../services/api';
import {formatDateYYYYMMDD} from '../../../utils/dateFormat'

const ChatContent = ({data}) => {
    console.log(data);
    const creative_id = data?.creative_id;
    const [messages, setMessages] = useState([]);
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(true);
    

    const getMessages = async()=>{
        try{
         setLoading(true);
         let res = await API({url:"/alpha_cst_designer/getactions",method:"POST",data:{creative_id}})
         if(res.status === 'SUCCESS')
         {
           setMessages(res.data);
         }
         else{
            setMessages([]);
         }
         setLoading(false);
        }catch(err)
        {     setLoading(false);
             console.log(err)
        }
    }
    useEffect(()=>{
      getMessages();
    },[creative_id])
    
    const getStatusColor = (title) => {
        const colors = {
            'Accepted': 'bg-green-100 text-green-800 border-green-200',
            'Created': 'bg-blue-100 text-blue-800 border-blue-200',
            'Rejected': 'bg-red-100 text-red-800 border-red-200',
            'Pending': 'bg-yellow-100 text-yellow-800 border-yellow-200',
        };
        return colors[title] || 'bg-gray-100 text-gray-800 border-gray-200';
    };

    const renderMessage = (notification, index) => {
        return (
            <div className="bg-white border rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow">
                {/* Action */}
                <div className="mb-3 flex items-start">
                    <span className="text-sm font-medium text-gray-700 w-24 flex-shrink-0">Action:</span>
                    <div className="flex-1 flex items-center justify-between">
                        <span>
                            {notification.title}
                        </span>
                        <span className="text-xs text-gray-500">
                            {formatDateYYYYMMDD(notification.date)}
                        </span>
                    </div>
                </div>
    
                {/* Done by */}
                <div className="mb-2 flex items-start">
                    <span className="text-sm font-medium text-gray-700 w-24 flex-shrink-0">Done by:</span>
                    <span className="text-sm text-gray-900 font-semibold flex-1">{notification.name}</span>
                </div>
    
                {/* Message */}
                <div className="flex items-start">
                    <span className="text-sm font-medium text-gray-700 w-24 flex-shrink-0">Message:</span>
                    <span className="text-sm text-gray-600 flex-1">{notification.message}</span>
                </div>
            </div>
        );
    };
    return (
        <>
        <div className="flex justify-evenly border-b pb-3 mb-4">
            <h5 className="text-lg font-semibold text-gray-800">
                Campaign : {data?.creative_name}
            </h5>
            <p className="text-sm text-gray-500 mt-1">
                Notifications ({messages.length})
            </p>
        </div>

        {loading ? (
            <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">Loading notifications...</div>
            </div>
        ) : messages.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-gray-400">
                <svg className="w-16 h-16 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                </svg>
                <p>No notifications yet</p>
            </div>
        ) : (
            <div className="space-y-3 overflow-y-auto max-h-[850px]">
                {messages.map((notification, index) => (
                    <div key={`${notification.name}-${notification.created_at}-${index}`}>
                        {renderMessage(notification, index)}
                    </div>
                ))}
            </div>
        )}
    </>
    );
};

export default ChatContent;
